import React, { type HTMLAttributes, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { Typography } from '../../../DesignSystem';

import { StyledSearchListItemSpacer, StyledSearchListItemWrapper, StyledThumbnail } from './styles';

interface CollectibleItemProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    name: string;
    thumbnail: string;
    focused?: boolean;
    onFocused?: (link: string) => void;
}

export function CollectibleItem({ name, thumbnail, id, focused, onFocused, ...rest }: CollectibleItemProps) {
    const contractId = id.replace(/-/g, '/');
    const link = `/collectible/eth/${contractId}`;

    useEffect(() => {
        focused && onFocused?.(link);
    }, [focused, link, onFocused]);

    return (
        <Link to={link}>
            <StyledSearchListItemWrapper {...rest} $focused={focused}>
                <StyledThumbnail src={thumbnail} />
                <Typography variant="h3" type="label" size={14} weight="700">
                    {name}
                </Typography>
                <StyledSearchListItemSpacer />
            </StyledSearchListItemWrapper>
        </Link>
    );
}
